import { Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import ManagerBase from "./ManagerBase";

class TaskManager extends ManagerBase {
	constructor () {
		super("taskManager");

		this.remoteClassName = "task";
	}

	cancel (task) {
		const rd = NousCore.api.createRequest({ item: task.export() });
		const requestedAction = "cancel";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						task.import(data.items[0]);
						task.clean();

						return {
							data: task,
							requestedAction,
							status: "ok"
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}

	close (task) {
		const rd = NousCore.api.createRequest({ item: task.export() });
		const requestedAction = "close";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						task.import(data.items[0]);
						task.clean();

						return {
							data: task,
							requestedAction,
							status: "ok"
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}

	getListByActivityGuid (activityGuid, filters) {
		const rd = NousCore.api.createRequest({ filters, item: { activityGuid } });
		const requestedAction = "get-list-by-activity-guid";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	getListByActivityGuidList (activityGuidList, filters) {
		const rd = NousCore.api.createRequest({ filters, item: { activityGuidList } });
		const requestedAction = "get-list-by-activity-guid-list";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}
}

const taskManager = new TaskManager();

Shark.registerController(taskManager);

export default taskManager;


// taskManager.addMethod("create", function (task) {
// 	Shark.requestRemoteData({
// 		context: taskManager,
// 		data: {an: "insert", d: task.collectData(), cx: "Task"},
// 		complete: function (response) {
// 			if (response.isSuccess) {
// 				var responseData = response.data;

// 				switch (responseData.rc) {
// 					case 1:
// 						Shark.appData.taskList = Shark.appData.taskList || [];

// 						Shark.get("newTask").parse(responseData.rows[0]);
// 						this.emit("created");

// 						Shark.get("taskList").push(Shark.get("newTask"));
// 						this.emit("listChanged");
// 						break;
// 					case 7:
// 						this.emit("error", "error_missingData");
// 						break;
// 					case 9:
// 						this.emit("error", "error_default");
// 						break;
// 				}
// 			}
// 		}
// 	});
// });

// taskManager.addMethod("getList", function (activityId) {
// 	Shark.requestRemoteData({
// 		context: taskManager,
// 		data: {an: "getList", d: {activityId: activityId}, cx: "Task"},
// 		complete: function (response) {
// 			if (response.isSuccess) {
// 				var responseData = response.data;

// 				switch (responseData.rc) {
// 					case 1:
// 						const taskList = Shark.getInstanceList("Task", responseData.rows);

// 						Shark.set("taskList", taskList);

// 						this.emit("listChanged");
// 						break;
// 					case 7:
// 						this.emit("error", "error_missingData");
// 						break;
// 					case 9:
// 						this.emit("error", "error_default");
// 						break;
// 				}
// 			}
// 		}
// 	});
// });

// taskManager.addMethod("update", function (task) {
// 	Shark.requestRemoteData({
// 		context: taskManager,
// 		data: {an: "update", d: task.collectData(), cx: "Task", userGuid: Shark.get("currUser").id},
// 		complete: function (response) {
// 			if (response.isSuccess) {
// 				var responseData = response.data;

// 				switch (responseData.rc) {
// 					case 1:
// 						task.parse(responseData.rows[0]);
// 						this.emit("updated");
// 						this.emit("listChanged");
// 						break;
// 					case 7:
// 						this.emit("error", "error_missingData");
// 						break;
// 					case 9:
// 						this.emit("error", "error_default");
// 						break;
// 				}
// 			}
// 		}
// 	});
// });

// Shark.registerController(taskManager);

// export { taskManager };